import { useState, useEffect } from "react";

// --- CUSTOM HOOK: Number Counter Animation ---
export const useCounter = (end, duration = 2000) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
        const endValue = parseInt(String(end).replace(/,/g, "").replace(/\+/g, ""), 10) || 0;
    if (endValue === 0) return;

    const totalFrames = Math.round(duration / 16);
    const increment = endValue / totalFrames;
    
    let frame = 0;
    const counter = () => {
      frame++;
      const currentCount = Math.min(Math.floor(increment * frame), endValue);
      setCount(currentCount);
      if (frame < totalFrames) {
        requestAnimationFrame(counter);
      }
    };
    
    requestAnimationFrame(counter);
  }, [end, duration]);

  return count;
};
